<div class="ev-card charger-panel" data-testid="charger-panel-container">
  @if (chargerType == 'disabledChargingstation') {
    <button class="ev-button primary" data-testid="charger-panel-reenable-btn" (click)="unmark()">{{ languageService.languageJSON.Global_ReEnable }}</button>
  }
  @if (chargerType == 'favoriteChargingstation') {
    <button class="ev-button primary" data-testid="charger-panel-unmark-btn" (click)="unmark()">{{ languageService.languageJSON.Global_Unmark }}</button>
  }
  <button class="ev-button" data-testid="charger-panel-back-btn" (click)="goBack()">{{ languageService.languageJSON.Global_Back }}</button>
</div>